import { defineStore } from 'pinia'
import http from "@/services/configService";
import autenticacaoService from '@/services/Autenticacao/autenticacaoService'

export const useConfiguracoesHttpStore = defineStore('configuracoesHttp', {

    state: () => {
        return {
            configuracoesHttp: {
                EnderecoApi: '',
                NS: 0,
                MultiTenant: false,
                Usuario: process.env.VUE_APP_USER,
                Senha: process.env.VUE_APP_PASSWORD,
                Token: ''
            }
        }
    },
    actions: {
        async configurarAplicacao(ns) {            
            this.configuracoesHttp.NS = ns;
            this.configuracoesHttp.MultiTenant = window.MultiTenant;
            this.configuracoesHttp.EnderecoApi = (this.configuracoesHttp.MultiTenant) ? window.EnderecoAPI.replace("numero_serie", ns) : window.EnderecoAPI
            http.defaults.baseURL = this.configuracoesHttp.EnderecoApi 
        },
        async setup(){
            this.configuracoesHttp.Token = await autenticacaoService()
        }
    }
})